export default __webpack_public_path__ + "static/media/1.58940d6d.png";